import { useSelector } from 'react-redux';
import { Announcement } from 'ui/announcement';
import { useQueryIsSdkSetupWorking } from 'modules/anonymousUserTracking/hooks/useQueryAnonCriteria';
import { selectIsAnonymousUserCriteriaFeatureFlagOn } from 'core/userContext';

export const SDKSetupNotWorkingAnnouncement = () => {
  const { isSdkSetupWorking } = useQueryIsSdkSetupWorking();
  const isAnonUserTrackingEnabled = useSelector(selectIsAnonymousUserCriteriaFeatureFlagOn);

  if (!isAnonUserTrackingEnabled) return null;
  if (isSdkSetupWorking) return null;
  return (
    <Announcement data-test="sdk-not-working-announcement">
      <b>Criteria data not detected.</b> Please check your configuration settings or consult our
      docs for additional testing instructions.
      {/* add back when announcement link is provided */}
      {/* &nbsp;&nbsp;
      <WebLink2 href={'#'} target="_blank">
        Learn more
      </WebLink2> */}
    </Announcement>
  );
};
